"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Image from "next/image";

export default function Hero() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start start", "end start"],
    });

    const y = useTransform(scrollYProgress, [0, 1], [0, -300]);

    return (
        <section ref={ref} className="relative h-screen w-full overflow-hidden flex items-center justify-center">
            {/* Background Image Placeholder */}
            <div className="absolute inset-0 z-0 bg-[#1C1C1C]">
                {/* Replace with actual image */}
                <Image
                    src="/heroimage.jpg"
                    alt="Hero background"
                    fill
                    priority
                    className="object-cover object-center"
                />
                <div className="absolute inset-0 bg-black/20" />
            </div>

            <div className="relative z-10 container mx-auto px-6 md:px-20 lg:px-9 h-full flex flex-col justify-end pb-32 md:pb-48">
                <motion.div
                    style={{ y }}
                    className="flex flex-row items-stretch justify-end gap-6 md:gap-8"
                >
                    {/* Vertical Separator */}
                    <div
                        className="w-[2px] bg-white/50 hidden md:block origin-bottom animate-scale-y"
                    />

                    <h1
                        className="text-5xl md:text-6xl lg:text-[81px] font-medium leading-tight text-left animate-reveal-up"
                    >
                        Bridging imagination <br />
                        and reality.
                    </h1>
                </motion.div>
            </div>
        </section>
    );
}
